module.exports = __webpack_public_path__ + "assets/src/style/img/footer-umcg.png?1944083d2056f3f60c0a87b171d56161";